import { yupResolver } from '@hookform/resolvers/yup';
import React, { memo, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';

import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { getEndpointUrl } from "../../Utils/Common";

const CreateType = ({ onCallback, show, close, brands }) => {

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken, setAccessToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {

    }, [isLoading]);

    const validationSchema = Yup.object().shape({
        brand_id: Yup.string().required('Field harus diisi'),
        typeName: Yup.string().required('Field harus diisi'),
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        setLoading(true);

        let formData = new FormData();

        formData.append('brand_id', data.brand_id);
        formData.append('typeName', data.typeName);
        formData.append('user_id', userLogin.id);

        fetch(getEndpointUrl() + '/v2/car_type', {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.success("Yay, Data tipe berhasil diinput.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                close();

                onCallback(json.results.data);

            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Menyimpan data..." : "Input data tipe"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {isLoading ?
                        <Modal.Body>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                            </div>
                        </Modal.Body>
                        :
                        <>
                            <Modal.Body>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Merek</Form.Label>
                                    <Form.Select {...register("brand_id")} isInvalid={errors.brand_id ? true : false} autoComplete="off">
                                        <option value="">-- Pilih Merek --</option>
                                        {brands && brands.map(brand => (
                                            <option key={brand.id} value={brand.id}>{brand.companyName}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Nama Tipe</Form.Label>
                                    <Form.Control type="text" {...register("typeName")} isInvalid={errors.typeName ? true : false} autoComplete="off" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={close}> Batal </Button>
                                <Button variant="success" type="submit">Input data tipe</Button>
                            </Modal.Footer>
                        </>
                    }
                </Form>
            </Modal>
        </>
    );
}

export default memo(CreateType);
